const pageNameKey = "dashboardPanel";

export const dashboardPanelEn = {
  [pageNameKey]: {
    toggleToolTipText: "Show last values",
    timeSeriesInfoToolTipText: "Timeseries info",
    warningMessage:
      "For some of the chosen nodes, data is not representable in numeric format so they were excluded from the graph.",
  },
};

export const dashboardPanelPtBr = {
  [pageNameKey]: {
    toggleToolTipText: "Mostrar últimos valores",
    timeSeriesInfoToolTipText: "Informações da série temporal",
    warningMessage:
      "Para alguns dos nós selecionados, os dados não são representáveis em formato numérico, por isso eles foram excluídos do gráfico.",
  },
};

export const dashboardPanelDe = {
  [pageNameKey]: {
    toggleToolTipText: "Zeige die letzten Werte",
    timeSeriesInfoToolTipText: "Zeitreihen-Info",
    warningMessage:
      "Für einige der ausgewählten Knoten sind die Daten nicht im numerischen Format darstellbar, daher wurden sie aus dem Diagramm ausgeschlossen.",
  },
};

export const dashboardPanelZhHans = {
  [pageNameKey]: {
    toggleToolTipText: "显示最后的值",
    timeSeriesInfoToolTipText: "时间序列信息",
    warningMessage:
      "对于某些选定的节点，数据无法以数字格式表示，因此它们已从图表中排除。",
  },
};

export const dashboardPanelIt = {
  [pageNameKey]: {
    toggleToolTipText: "Mostra gli ultimi valori",
    timeSeriesInfoToolTipText: "Info di serie temporali",
    warningMessage:
      "Per alcuni dei nodi scelti, i dati non sono rappresentabili in formato numerico, quindi sono stati esclusi dal grafico.",
  },
};

export const dashboardPanelEs = {
  [pageNameKey]: {
    toggleToolTipText: "Mostrar últimos valores",
    timeSeriesInfoToolTipText: "Información de series temporales",
    warningMessage:
      "Para algunos de los nodos seleccionados, los datos no se pueden representar en formato numérico, por lo que se excluyeron del gráfico.",
  },
};

export const dashboardPanelNl = {
  [pageNameKey]: {
    timeSeriesInfoToolTipText: "Tijdreeksinformatie",
    toggleToolTipText: "Toon de laatste waarden",
    warningMessage:
      "Voor sommige van de geselecteerde knooppunten zijn de gegevens niet in numerieke vorm weer te geven; daarom zijn deze uit de grafiek uitgesloten.",
  },
};

export const dashboardPanelTr = {
  [pageNameKey]: {
    timeSeriesInfoToolTipText: "Zaman serisi bilgisi",
    toggleToolTipText: "Son değerleri göster",
    warningMessage:
      "Seçilen düğümlerden bazıları için veriler sayısal formatta temsil edilemediğinden grafiğin dışında bırakıldılar.",
  },
};
